<template lang="pug">
  v-container(fluid)
    v-row
      calendar-nav( :isoWeek.sync="selectorIsoWeek" :allowNavigationToPast="false")
    v-row
      v-container.pa-0(v-if="menuOfferCollection === null" fluid)
        v-skeleton-loader(type="list-item-three-line@7")
      calendar-list.pt-0.pb-0(v-if="menuOfferCollection && menuOfferCollection.length"
        v-for="(menuOfferItem, idx) in menuOfferCollection" :key="idx"
        :offerItem="menuOfferItem" :date="date")

</template>

<script lang="ts">
import Vue from 'vue'
import CalendarNav from '@/components/dailymenu/calendar/CalendarNav.vue'
import CalendarList from '@/components/dailymenu/calendar/CalendarList.vue'
import {Component, Prop} from "vue-property-decorator";
import DailyMenuOffer from "@/model/dailymenu/DailyMenuOffer";
import MenuReservationItem from "@/model/dailymenu/MenuReservationItem";

@Component({
  components: {
    CalendarNav,
    CalendarList
  }
})

export default class CalendarSelector extends Vue {

  @Prop({type: String, required: true}) readonly isoWeek!: string
  @Prop({type: Date}) date!: Date
  @Prop({type: Array as () => DailyMenuOffer[] | null}) menuOfferCollection!: DailyMenuOffer[] | null
  @Prop({type: Array as () => MenuReservationItem[] | null}) reservationCollection!: MenuReservationItem[] | null

  get selectorIsoWeek(): string {
    return this.isoWeek
  }

  set selectorIsoWeek(newVal: string) {
    this.$emit('update:isoWeek', newVal)
  }

  onChangeDate (date: string): void {
    this.$emit('update:date', new Date(date))
  }
}
</script>

<style lang="stylus" scoped>

.calendar-selector {
  flex-direction: column
}

.nav {
  flex: 1;
  align-items: stretch;
  display: flex
}

.list {
  flex: 12;
  overflow: auto
}
</style>
